import { Check, Copy } from 'lucide-react';
import { cn } from '@/nucleo/utilitarios';
import { useCopyToClipboard } from '@/lib/useCopyToClipboard';

import { ScreenOnlyCode } from './print/PrintMode';

interface CodeBlockProps {
  code: string;
  language?: string;
  className?: string;
}

export function CodeBlock({ code, language = 'tsx', className }: CodeBlockProps) {
  const { copy, copied } = useCopyToClipboard({ silent: true });

  return (
    <div
      className={cn(
        'relative group rounded-xl border border-border bg-muted/50 overflow-hidden',
        className,
      )}
    >
      <div className="flex items-center justify-between px-4 py-2 border-b border-border bg-muted/30">
        <span className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
          {language}
        </span>
        {/* "Copiar" só serve à tela: no documento impresso não aparece. */}
        <ScreenOnlyCode>
          <button
            type="button"
            onClick={() => void copy(code)}
            className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Copiar código"
          >
            {copied ? (
              <>
                <Check className="h-3.5 w-3.5 text-success-text" />
                <span className="text-success-text">Copiado!</span>
              </>
            ) : (
              <>
                <Copy className="h-3.5 w-3.5" />
                <span>Copiar</span>
              </>
            )}
          </button>
        </ScreenOnlyCode>
      </div>
      <pre
        className="p-4 overflow-x-auto text-sm font-mono leading-relaxed text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- o código rola na horizontal e o teclado precisa alcançar a rolagem (WCAG 2.1.1)
        tabIndex={0}
        aria-label="Exemplo de código"
      >
        <code>{code.trim()}</code>
      </pre>
    </div>
  );
}
